import { createFileRoute } from "@tanstack/react-router";
import { number, object } from "zod";

const searchSchema = object({
  folderId: number().optional(),
});

export const Route = createFileRoute("/sources/fleets/$id/dashboards/")({
  staticData: {
    title: "common.dashboards",
  },
  validateSearch: searchSchema,
});
